import React, { useState, useEffect } from 'react';

import styles from './secondary-navbar.styles.css';

export const SecondaryNavbar = ({ show, newClientList }) => {
  const [left, setLeft] = useState(-272);

  useEffect(() => {
    if (show) {
      setLeft(80);
    } else {
      setLeft(-272);
    }
  }, [show]);

  return (
    <div className={`${styles.secondaryNav} ${show ? styles.active : ''}`} style={{ left: left }}>
      {show && <show.secondary newClientList={newClientList} />}
    </div>
  );
};
